// src/components/pages/backtest/partials/PortfolioInputSection.js (새 파일)

import React from 'react';
import { NumericFormat } from "react-number-format";
import TickerRow from '../../../TickerRow/TickerRow';
import styles from '../style/BacktestPage.module.css';

// SVG Helper 함수도 분리하거나 여기에 재정의
const getRemoveButtonSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
);

const PortfolioInputSection = ({ setup, actions, runner, auth, t }) => {
    return (
        <div className={styles.inputContainer}>
            <h2>{t("backtest.TickerAndWeight")}</h2>
            <div className={styles.inputSection}>
                {setup.rows.map((row, index) => (
                    <div key={index} className={styles.inputRow}>
                        <TickerRow
                            value={row.ticker}
                            onChange={(newTicker) => setup.handleChange(index, "ticker", newTicker)}
                            existingTickers={setup.rows.map(r => r.ticker)} 
                        />
                        <NumericFormat
                            value={row.weight}
                            onValueChange={(values) => setup.handleChange(index, "weight", values.value)}
                            className={styles.numericInput} thousandSeparator={true} allowNegative={false} decimalScale={2} suffix="%" placeholder={t("backtest.weightPlaceholder")}
                        />
                        <button onClick={() => setup.handleRemoveRow(index)} className={styles.removeButton} aria-label="Remove Ticker">
                            {getRemoveButtonSVG()}
                        </button>
                    </div>
                ))}
            </div>
            
            {/* 입력 액션 버튼 */}
            <div className={styles.buttonSection}>
                <button onClick={setup.handleAddRow} className={styles.addButton}>{t("backtest.addTicker")}</button>
                <div className={`${styles.weightSum} ${runner.getWeightSumColor(setup.totalWeight)}`}>
                    {t("backtest.totalWeight")}: {setup.totalWeight.toFixed(2)}%
                </div>
            </div>
            
            <div className={styles.buttonSection}>
                <button onClick={setup.handleReset} className={styles.resetButton}>{t("backtest.resetButton")}</button>
                <button onClick={setup.handleLoadExamples} className={styles.exampleButton}>{t("backtest.loadExamplesButton")}</button>
            </div>

            {/* 내 포트폴리오 불러오기 버튼 섹션 */}
            <div className={styles.buttonSection} style={{ marginTop: '10px' }}>
                <button
                    onClick={() => actions.fetchUserPortfolios(false)} 
                    className={styles.resetButton} 
                    disabled={actions.isPortfoliosLoading}
                    style={{ 
                        width: '100%', backgroundColor: actions.isPortfoliosLoading ? '#adb5cd' : (actions.isLoadModalOpen ? '#dc3545' : '#6c757d'), 
                        color: 'white', opacity: actions.isPortfoliosLoading ? 0.7 : 1 
                    }}
                    title={!auth.isAuthenticated ? t('newPortfolioModal.loginRequiredTooltip') : ''}
                >
                    {actions.isPortfoliosLoading ? t('backtest.loading') : (actions.isLoadModalOpen ? (t('backtest.close') || "닫기") : (t('backtest.loadMyPortfolioButton') || "내 포트폴리오 불러오기"))}
                </button>
            </div>

            {/* 포트폴리오 목록 표시 (드롭다운) */}
            {actions.isLoadModalOpen && actions.userPortfolios.length > 0 && (
                <div className={styles.portfolioDropdown} style={{ marginTop: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f8f9fa' }}>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1em', fontWeight: 'bold' }}>{t('backtest.selectPortfolio') || '포트폴리오를 선택하세요.'}</h3>
                    <ul style={{ listStyle: 'none', padding: 0, maxHeight: '200px', overflowY: 'auto' }}>
                        {actions.userPortfolios.map(p => {
                            const isAll = p.portfolioType === 'ALL';
                            return (
                            <li key={p.portfolioId} className={styles.portfolioListItem} 
                                style={{ 
                                    fontWeight: isAll ? 'bold' : 'normal', 
                                    backgroundColor: isAll ? '#e9f7ff' : '#f8f9fa', 
                                    color: isAll ? '#007bff' : '#343a40' 
                                    }}>
                                <span onClick={() => actions.handleLoadPortfolio(p)} style={{ flexGrow: 1, cursor: 'pointer' }}>{p.name}</span>
                                {p.portfolioType === 'PRIVATE' && (
                                    <button onClick={(e) => { 
                                        e.stopPropagation(); 
                                        actions.handleStartTrackingPortfolio(p); }} 
                                        disabled={actions.isPortfoliosLoading} 
                                        style={{ 
                                            padding: '5px 10px', fontSize: '0.8em', backgroundColor: '#28a745', 
                                            color: 'white', border: 'none', borderRadius: '4px', marginLeft: '10px' 
                                            }}>
                                        {t('backtest.startTracking') || '성과 추적 시작'}
                                    </button>
                                )}
                            </li>
                        )})}
                    </ul>
                </div>
            )}

            {/* 저장 버튼 섹션 */}
            <div className={styles.buttonSection} style={{ marginTop: '10px' }}>
                <button onClick={actions.handleOpenSaveModal} className={styles.runButton} disabled={setup.isLoadingBenchmark} style={{ width: '100%', backgroundColor: '#007bff' }} title={!auth.isAuthenticated ? t('newPortfolioModal.loginRequiredTooltip') : ''}>
                    {t('backtest.savePortfolioButton') || "포트폴리오 저장"}
                </button> 
            </div>
        </div>
    );
};

export default PortfolioInputSection;